export default __webpack_public_path__ + "static/media/58.4fdf6f66.jpg";